import TestimonialRepository from "../TestimonialRepository"

export default class PricingTestimonial extends TestimonialRepository {
    static schemaId = "pricing_testimonial"

    constructor() {
        super(PricingTestimonial.schemaId)
    }
}
